import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, FremiumGuard } from '../../guards';
import { ProfileComponent } from './profile/profile.component';
import { KnowTheRulesComponent } from './know-the-rules/know-the-rules.component';
import { InvitesComponent } from './invites/invites.component';
import { VouchersComponent } from './vouchers/vouchers.component';

export const routes: Routes = [
  { path: 'convites', canActivate: [AuthGuard, FremiumGuard], component: InvitesComponent },
  { path: 'vouchers', canActivate: [AuthGuard, FremiumGuard], component: VouchersComponent },
  { path: 'indique', canActivate: [AuthGuard, FremiumGuard], children: [
      { path: '', component: ProfileComponent },
      { path: 'conheca-as-regras', component: KnowTheRulesComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MemberGetMemberRoutingModule {
}
